import { Component, OnDestroy, OnInit } from '@angular/core';
import { InterlayerCardService } from 'app/services/interlayer-card.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-interlayer-ref-cards',
  templateUrl: './interlayer-ref-cards.component.html',
  styleUrls: ['./interlayer-ref-cards.component.css']
})
export class InterlayerRefCardsComponent implements OnInit, OnDestroy {

	currentList: any[];

	private selectionList: any[];
	private editedList: any[];

	currentRefCardSub: Subscription;
	selectionListSub: Subscription;
	constructor(
		private iCardService: InterlayerCardService
	) { }


	ngOnInit() {
		this.currentRefCardSub = this.iCardService.currentRefCardBS.subscribe(data => {
			// if (!data || !data.id) {
			// 	return;
			// }
			// const idx = this.iCardService.findCardIdx(data.card, this.cards, this.iCardService.refPrefix);
			// if (idx > -1) {

			// } else {
			// 	this.cards.push(data.card);
			// }
		});
		this.selectionListSub = this.iCardService.refCardSelectionListBS.subscribe(data => {
			// if (!data || !data.ids) {
			// 	this.selectionList = [];
			// 	return;
			// }
			// this.selectionList = data.ids.map(id => this.mainDataService.getDataAttrs(id));
			// if (this.currentList !== this.selectionList) {
			// 	this.changeDisplayMode('selection');
			// }
			// this.selectionList = data.list;
		})
	}
	ngOnDestroy(): void {
		this.currentRefCardSub.unsubscribe();
		this.selectionListSub.unsubscribe();
	}

}
